import React from 'react'
import Card from '../../../atoms/card/Card'
import CircleIcon from '../../../atoms/icon/CircleIcon'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'
import classNames from 'classnames'
import IconButton from '../../../molecules/iconbutton/IconButton'

import './SimulationSetting.scss'
import { IconType } from '../../../atoms/icon/Icon'

interface SimulationSettingProps {
  icon: IconType
  readOnly?: boolean
  onTrashClick: () => void
  warning?: boolean
}

const SimulationSetting: React.FC<SimulationSettingProps> = ({ children, icon, readOnly, onTrashClick, warning }) =>
  <Card className={classNames('simulation-setting-container', { warning })}>
    <InlineGroup spread>
      <InlineGroup spaceLeft={6} stretch>
        <CircleIcon type={icon} colour='blue' circleSize={16} size={10} />
        {children}
      </InlineGroup>
      {!readOnly && <IconButton
        onClick={onTrashClick}
        icon='trash'
        color='blue'
        wide={false}
        light={false}
        mini
        noUi
      />}
    </InlineGroup>
  </Card>

export default SimulationSetting